import { render, staticRenderFns } from "./RefereeDetail.vue?vue&type=template&id=e494597a&scoped=true&"
import script from "./RefereeDetail.vue?vue&type=script&lang=js&"
export * from "./RefereeDetail.vue?vue&type=script&lang=js&"
import style0 from "./RefereeDetail.vue?vue&type=style&index=0&id=e494597a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e494597a",
  null
  
)

export default component.exports